import { post } from '@/utils/request'
import { WECHAT_APPID } from '../../config/env'
import wx from 'weixin-js-sdk'

// 修改微信页面 title 的全局方法
export function setWxTitle(title) {
  if (typeof title === 'string') {
    document.title = title
    // 兼容部分微信内置浏览器
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = '/favicon.ico'
    iframe.onload = function () {
      setTimeout(function () {
        document.body.removeChild(iframe)
      }, 9)
    }
    document.body.appendChild(iframe)
  }
}

// 检查是否在微信浏览器中
export function isWeixinBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

// 生成随机字符串
export function randomString(length) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

// 初始化微信分享
export async function initWxShare() {
  try {
    if (!isWeixinBrowser()) {
      console.log('非微信环境，跳过微信分享初始化')
      return
    }

    // 获取当前页面完整URL，包含查询参数但不包含hash
    const currentUrl = window.location.href.split('#')[0]
    console.log('当前URL:', currentUrl)

    const timestamp = Math.floor(Date.now() / 1000).toString()
    const nonceStr = randomString(32)

    const res = await post('/api/wx/jsconfig', {
      url: currentUrl,
      app_id: WECHAT_APPID,
      timestamp: timestamp,
      nonceStr: nonceStr
    })

    if (res.result.state === 'ok') {
      return new Promise((resolve, reject) => {
        wx.config({
          debug: false,
          appId: WECHAT_APPID,
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: res.result.signature,
          jsApiList: [
            'checkJsApi',
            'hideMenuItems',
            'showMenuItems',
            'getLocation',
            'openLocation',
            'closeWindow',
            'chooseWXPay',
            'updateAppMessageShareData'
          ]
        })

        wx.ready(() => {
          console.log('wx.config 配置成功')
          resolve()
        })

        wx.error((res) => {
          console.error('微信JS-SDK配置失败:', res)
          reject(res)
        })
      })
    } else {
      console.error('获取签名失败:', res.result.message)
    }

  } catch (error) {
    console.error('微信分享初始化失败:', error)
  }
}

// 转发给朋友
export function forwardToFriend(options = {}) {
  const { title, desc, link, success, fail } = options
  console.log(link)

  if (!isWeixinBrowser()) {
    // 非微信环境，复制链接
    copyToClipboard(link || window.location.href)
    return
  }

  // 微信环境，使用微信分享
  if (typeof wx !== 'undefined' && wx.ready) {
    wx.ready(() => {
      wx.updateAppMessageShareData({
        title: title || document.title,
        desc: desc || '',
        link: link || window.location.href,
        imgUrl: `${window.location.origin}/logo/share-logo.png`,
        success: success || (() => { }),
        fail: fail || (() => { })
      })
    })
  }
}

// 复制文本到剪贴板
function copyToClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      console.log('链接已复制到剪贴板')
    }).catch(() => {
      fallbackCopyTextToClipboard(text)
    })
  } else {
    fallbackCopyTextToClipboard(text)
  }
}

// 兼容性复制方法
function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    if (successful) {
      console.log('链接已复制到剪贴板')
    }
  } catch (err) {
    console.error('复制失败:', err)
  }

  document.body.removeChild(textArea)
} 